import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';
import {
  AUTHORIZED_URL_PREFIX,
  AxiosConfig
} from '../../Utils/Constants'
import Papa from 'papaparse';
import LykioButton from '../common/LykioButton';
import Loading from '../common/Loading';
import t from '../../Utils/Translation';



const EniPlatformUsageDownload = ({ selectedEditionCode }) => {
  const [loading, setLoading] = useState(false);
  const [userRows, setUserRows] = useState([
    {
      META_USERID: "STRING",
      META_MAIL: "EMAIL",
      COD_EDIZIONE: "STRING",
      DATA_FRUIZIONE: "DATE",
      DURATA_EQUIVALENTE: "NUMBER",
      /*DURATA_CODICE_EDIZIONE: "NUMBER",*/
      STATUS: "STRING",
    }
  ]);

  const unwantedEmails = [
    "admin@ccseducation.com",
    "fernando.salvetti@external.identity.eni.com",
    "angela.nembrini@external.identity.eni.com","barbara.bertagni@external.identity.eni.com",
    "Angela.Nembrini@external.eni.com","Barbara.Bertagni@external.eni.com",
    "Francesco.Galina@external.eni.com","eni_testadmin@mailinator.com","eni_test1@mailinator.com",
  ];
  
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${AUTHORIZED_URL_PREFIX}${"/user/getUsersActivity"}`,
          AxiosConfig()
        );
  
        //console.log("data.userStats:",data.userStats);
  
        if (data.userStats.length > 0) {
          const newUserRows = [];
          // console.log('all the entries>>>',data.userStats.length)
          let previousUser = null;
          for (let i = 0; i < data.userStats.length; i++) {
            const user = data.userStats[i];
            // console.log('registration>>', user.registrationDate);
            if(!unwantedEmails.includes(user.email)){
              // Find the duration for the user's edition code
              const editionCodeDuration = calculateEditionCodeDuration(user, previousUser);
              previousUser = user;

              newUserRows.push({
                META_USERID: user.eni_id ? user.eni_id : '',
                META_MAIL: user.email,
                COD_EDIZIONE: user.editionCodeName,
                /*COD_EDIZIONE: user.registrationDate && new Date(user.registrationDate) > new Date('2023-11-23')
                ? 'COSV2794B-001-23'
                : 'COSV2794B-001-22',*/
                DATA_FRUIZIONE: user.date==="" ? "" : convertDateToDDMMYYYY(new Date(user.date)),
                DURATA_EQUIVALENTE: editionCodeDuration,
                /* DURATA_EQUIVALENTE: Math.ceil(user.seconds),
                DURATA_CODICE_EDIZIONE: editionCodeDuration,*/
                STATUS: user.status,
              });
            }
          }
          setUserRows([...userRows, ...newUserRows]);
          console.log(userRows);
        }
        

      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    };

    const calculateEditionCodeDuration = (user, previousUser) => {
      if (!previousUser || user.email !== previousUser.email) {
        return Math.ceil(user.seconds);
      } else {
        const duration = Math.ceil(user.seconds - previousUser.seconds);
        return duration >= 0 ? duration : 0; // Ensure the duration is non-negative
      }
    };

    fetchData();
  }, []);



  const recreateCSV = () => {
    const filteredUserRows = selectedEditionCode === "All"
    ? userRows
    : userRows.filter((user) => {
        if (user.COD_EDIZIONE === selectedEditionCode || user.COD_EDIZIONE === "STRING") {
          return true;
        }
    });
  
    const csv = Papa.unparse(filteredUserRows, { header: true });
    const rows = csv.split(/\r?\n/); // Use a regular expression to split on '\r\n' or '\n'
    const modifiedRows = rows.map(row => row.replace(/$/,',')); // Replace the end of each row with a comma
    const modifiedCSV = modifiedRows.join('\r\n'); // Join the rows back together with '\r\n' as the separator
    const blob = new Blob([modifiedCSV], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `eni-platform-usage-${convertDateToDDMMYYYY(new Date())}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };


  if (loading) {
    return <Loading/>;
  }

  return (
    <div>
    <div>
    <LykioButton 
    style={{
      backgroundColor: selectedEditionCode ? '#003d7d' : 'rgba(0, 0, 0, 0.12)',
      color: selectedEditionCode ? 'white' : 'rgba(0, 0, 0, 0.26)'
      //boxShadow: selectedEditionCode ? 'inherit' : 'none'
    }} 
    onClick={recreateCSV} disabled={!selectedEditionCode}>{t('Download Eni Usage CSV File')}</LykioButton>
    </div>
  </div>
  );
};

export default EniPlatformUsageDownload;


function convertDateToDDMMYYYY(date) {
  if(date ==="NA"){
    return date;
  }
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

